import {Dispatch} from 'redux';
import {
  POCToolSummary,
  POCToolCategory,
  MiniTool,
} from '../../models/IPOCToolsContentManagement';
import {
  convertingPOCToolToDisplayPocToolContent,
  convertingToFinalObject,
} from '../../Util/converter';

export const SET_POCTOOLSUMMARY = 'SET_POCTOOLSUMMARY';
export const SET_POCTOOLCONTENT = 'SET_POCTOOLCONTENT';
export const SET_SUPERPOCTOOLCONTENT = 'SET_SUPERPOCTOOLCONTENT';
export const CLEAR_POCTOOL = 'CLEAR_POCTOOL';

export interface SetPOCToolSummary {
  type: 'SET_POCTOOLSUMMARY';
  POCToolSummary: POCToolSummary;
}
export interface SetSuperPOCToolContent {
  type: 'SET_SUPERPOCTOOLCONTENT';
  POCToolContent: MiniTool[];
  displayPocToolContent: any[];
}
export interface SetPOCToolContent {
  type: 'SET_POCTOOLCONTENT';
  POCToolContent: POCToolCategory[];
  displayPocToolContent: any[];
}
export interface ClearPOCTool {
  type: 'CLEAR_POCTOOL';
}

export type KnownAction =
  | SetPOCToolSummary
  | SetPOCToolContent
  | ClearPOCTool
  | SetSuperPOCToolContent;

export const actionCreators = {
  setPOCToolSummary: (POCToolSummary: POCToolSummary) => {
    return (dispatch: Dispatch<KnownAction>) => {
      dispatch({
        type: SET_POCTOOLSUMMARY,
        POCToolSummary: POCToolSummary,
      });
    };
  },
  setPOCToolContent: (displayPocToolContent?: any[], pcotoolContent?: any) => {
    if (!pcotoolContent) {
      pcotoolContent = convertingToFinalObject(displayPocToolContent);
    }
    if (!displayPocToolContent) {
      displayPocToolContent =
        convertingPOCToolToDisplayPocToolContent(pcotoolContent);
    }

    if (displayPocToolContent.length === 0) {
      return (dispatch: Dispatch<KnownAction>) => {
        dispatch({
          type: SET_POCTOOLCONTENT,
          POCToolContent: [],
          displayPocToolContent: [],
        });
      };
    }
    if (displayPocToolContent[0].type == 'minitool') {
      return (dispatch: Dispatch<KnownAction>) => {
        dispatch({
          type: SET_SUPERPOCTOOLCONTENT,
          POCToolContent: pcotoolContent,
          displayPocToolContent: displayPocToolContent,
        });
      };
    } else {
      return (dispatch: Dispatch<KnownAction>) => {
        dispatch({
          type: SET_POCTOOLCONTENT,
          POCToolContent: pcotoolContent,
          displayPocToolContent: displayPocToolContent,
        });
      };
    }
  },
  ClearPOCTool: () => {
    return (dispatch: Dispatch<KnownAction>) => {
      dispatch({
        type: CLEAR_POCTOOL,
      });
    };
  },
};
